import { render, staticRenderFns } from "./cardfull.vue?vue&type=template&id=2a88da76"
import script from "./cardfull.vue?vue&type=script&lang=js"
export * from "./cardfull.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports